import { Avatar, Stack, TextField, Typography } from "@mui/material";
import { DamsColors } from "../styles/DamsColors";
import React, { useState } from "react";
import { ModalInputProps } from ".";
import { DamsAppAsset } from "../../assets/registry";


const ModalInput: React.FC<ModalInputProps> = ({
    label,
    placeholder,
    type = 'email',
}) => {

    const [showPassword, setShowPassword] = useState(false);

    return (
        <Stack
            height={'100%'}
            width={'100%'}
        >
            {label &&
                <Typography
                    fontFamily={'Inter'}
                    color={DamsColors.Authentication.InputLabel}
                    fontSize={14}
                    fontWeight={500}
                    mb={0.75}
                >
                    {label}
                </Typography>
            }

            <TextField
                variant="standard"
                placeholder={placeholder ?? placeholder}
                type={type === 'hidden-text' ? 'password' : 'text'}
                InputProps={{
                    endAdornment: ((type === 'password') &&
                        <Avatar
                            src={DamsAppAsset.icons.help}
                            sx={styles.avatarIcons} />)
                }}
                fullWidth
                sx={styles.authInput}
            />
        </Stack>
    )
}

const styles = {
    authInput: {
        backgroundColor: 'white',
        borderRadius: '8px',
        border: `1px solid ${DamsColors.Authentication.InputBorder}`,
        height: '40px',
        justifyContent: 'center',
        color: DamsColors.Authentication.InputLabel,
        fontFamily: 'Inter',
        px: '15px',

        '& .MuiInput-underline:before': {
            borderBottom: 'none',
        },
        '& .MuiInput-underline:after': {
            borderBottom: 'none',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: 'none',
        },
    },

    avatarIcons: {
        width: '16px',
        height: '16px'
    }

}


export default ModalInput;
